import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../Card';
interface MetricCardProps {
  label: string;
  value: string;
  hint: string;
}
export function MetricCard({
  label,
  value,
  hint
}: MetricCardProps) {
  return <Card size="sm" data-id="element-206" data-mp="3nditeo6stvmw">
      <CardHeader data-id="element-207" data-mp="3nf2a2fwda8p7">
        <CardDescription className="font-mono text-xs uppercase tracking-[0.14em]" data-id="element-208" data-mp="3jbxdetyyx18h">
          {label}
        </CardDescription>
        <CardTitle className="font-mono text-2xl tabular-nums" data-id="element-209" data-mp="jvh574h0y8ak">{value}</CardTitle>
      </CardHeader>
      <CardContent data-id="element-210" data-mp="eyh1h07ndhmm">
        <p className="text-xs text-muted-foreground" data-id="element-211" data-mp="ey7j9ysugerh">{hint}</p>
      </CardContent>
    </Card>;
}